import { ArrowRight } from "lucide-react";

const Hero = () => {
  const scrollToWaitlist = () => {
    document.getElementById("waitlist")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>
            Your Personal Financial
            <span style={styles.titleAccent}>Operating System</span>
          </h1>

          <p style={styles.subtitle}>
            All your bills, subscriptions, and spending — finally in one place.
          </p>

          <button onClick={scrollToWaitlist} style={styles.primaryButton}>
            Join the Waitlist
            <ArrowRight
              style={{
                marginLeft: "0.5rem",
                height: "1.25rem",
                width: "1.25rem",
              }}
            />
          </button>

          <p style={styles.tagline}>
            Run your personal finances like a business
          </p>

          <div style={styles.imageContainer}>
            <div style={styles.imageWrapper}></div>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles: Record<string, React.CSSProperties> = {
  section: {
    position: "relative",
    overflow: "hidden",
    paddingTop: "3rem",
    paddingBottom: "3rem",
  },
  container: {
    maxWidth: "1280px",
    margin: "0 auto",
    padding: "0 1rem",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    maxWidth: "56rem",
    margin: "0 auto",
  },
  title: {
    fontSize: "clamp(1.75rem, 6vw, 3rem)",
    fontWeight: "600",
    marginBottom: "1.5rem",
    color: "#000",
    lineHeight: 1.2,
  },
  titleAccent: {
    display: "block",
    color: "#6366f1",
    marginTop: "0.5rem",
  },
  subtitle: {
    fontSize: "clamp(1rem, 3vw, 1.25rem)",
    color: "#6b7280",
    marginBottom: "2rem",
    maxWidth: "42rem",
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    padding: "0.875rem clamp(1.5rem, 5vw, 3rem)",
    fontSize: "clamp(1rem, 2.5vw, 1.125rem)",
    backgroundColor: "#6366f1",
    color: "#fff",
    border: "none",
    borderRadius: "0.75rem",
    cursor: "pointer",
    fontWeight: "500",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    transition: "all 0.3s",
  },
  tagline: {
    fontSize: "clamp(0.75rem, 2vw, 0.875rem)",
    color: "#6b7280",
    marginTop: "1rem",
  },
  imageContainer: {
    marginTop: "2rem",
    width: "100%",
    maxWidth: "80rem",
  },
  imageWrapper: {
    position: "relative",
    borderRadius: "1rem",
    overflow: "hidden",
  },
};

export default Hero;
